"use client"

import { useMemo } from "react"
import Typography from "@mui/material/Typography"
import type { IMeeting } from "src/interfaces/IMeeting"
import placeholder from "src/assets/placeholder.png"
import { Box, Card, CardContent, CardMedia, Chip, Divider, Grid } from "@mui/material"
import { CalendarToday, AccessTime, Storage, VideoFile } from "@mui/icons-material"
import { RecordingDownloadDropdown } from "../RecordingDownloadDropdown/RecordingDownloadDropdown"
import { DeleteOnZoomButton } from "../DeleteOnZoomButton/DeleteOnZoomButton"
import { Link } from "react-router-dom"

export default function RecordingCard(meeting: IMeeting) {
  const videoFile = useMemo(() => meeting.recording_files?.find((f) => f.file_type === "MP4"), [meeting])
  console.log('meeting.sk', meeting.sk)
  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString()
    } catch (e) {
      return dateString
    }
  }

  const formatTime = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleString()
    } catch (e) {
      return dateString
    }
  }

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        overflow: "hidden",
        borderRadius: 2,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
        },
        mb: 3,
        bgcolor: "white",
      }}
    >
      <Link
        to={`/recordingssss/${encodeURIComponent(meeting.sk)}`}
        style={{
          textDecoration: "none",
          display: "block",
          position: "relative",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            position: "relative",
            height: { xs: "180px", sm: "100%" },
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0) 50%)",
              display: "flex",
              alignItems: "flex-end",
              p: 2,
            }}
          >
            <Chip
              icon={<VideoFile />}
              label="Video"
              size="small"
              sx={{
                bgcolor: "rgba(255,255,255,0.9)",
                fontWeight: "medium",
                "& .MuiChip-icon": { color: "#2575fc" },
              }}
            />
          </Box>
        </Box>
      </Link>

      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, width: "100%" }}>
        <CardContent sx={{ flex: "1 0 auto", p: 3 }}>
          <Link to={`/recording/${encodeURIComponent(meeting.sk)}`} style={{ textDecoration: "none", color: "inherit" }}>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: "bold",
                mb: 2,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                height: "3.6em",
                "&:hover": { color: "#2575fc" },
              }}
            >
              {meeting.topic}
            </Typography>
          </Link>

          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <CalendarToday sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                <Typography variant="body2" color="text.secondary">
                  {formatDate(meeting.start_time)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <AccessTime sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                <Typography variant="body2" color="text.secondary">
                  {formatTime(meeting.start_time)}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Storage sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                <Typography variant="body2" color="text.secondary">
                  {(+(videoFile?.file_size || 0) / 1000000).toFixed(2).toString()} MB
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>

        {meeting.internal_status !== "completed" ? null : (
          <>
            <Divider />
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                p: 2,
                gap: 1,
                bgcolor: "rgba(0,0,0,0.02)",
              }}
            >
              <RecordingDownloadDropdown meeting={meeting} type="MP4" />
              <RecordingDownloadDropdown meeting={meeting} type="M4A" />
              <DeleteOnZoomButton meeting={meeting} />
            </Box>
          </>
        )}
      </Box>
    </Card>
  )
}
